import { ContextNotification, Span } from '@pandiafi/design-system'
import { t } from 'i18next'
import React from 'react'

export const ResendVerificationCodeErrorSection: React.FC = () => (
  <ContextNotification type="error">
    <Span className="text-common-red-6">
      {t('registration:verificationCodeResendError')}
    </Span>
  </ContextNotification>
)
